export default {
  UPDATING: 'ADMIN_VIEW_MARKET_SPACES_EDITOR_UPDATING',
  UPDATED: 'ADMIN_VIEW_MARKET_SPACES_EDITOR_UPDATED',
};
